import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router';
import { StyledButton } from "components/Buttons/DefaultButton/DefaultButton.styles";
import { SimpleModal } from '../../../../components/Modal';
import dayjs from 'dayjs';
import styles from '../CustomOfferDetailsPage.module.scss';
import {JobProps} from "utils/types";

interface BookAnotherTempProps {
  job: JobProps
}

const BookAnotherTemp: React.FC<BookAnotherTempProps> = ({ job }) => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handlePostNewJob = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  // T2-6729: use React postJob navigation (same as JobPostedPage) — legacy
  // F7 Home.getTempHandler is a no-op from Custom Offer Details.
  const handleConfirmPostNewJob = useCallback(() => {
    setIsModalOpen(false);
    const date = job?.startDate
      ? dayjs(job.startDate).format('YYYY-MM-DD')
      : undefined;
    history.push('postJob', { date });
  }, [job?.startDate, history]);

  return (
    <>
      <StyledButton
        variant="contained"
        color="primary"
        size="small"
        id="book-another-temp-for-date-button"
        data-testid="book-another-temp-for-date-button"
        className={styles.bookAnotherButton}
        onClick={handlePostNewJob}
      >
        Book Another Temp For This Date
      </StyledButton>
      <SimpleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Book Another Shift?</h2>
        <p>Do you need another temp for this day?</p>
        <p>{dayjs(job?.startDate).format('MMMM D, YYYY')}</p>
        <div>
          <StyledButton
            variant="contained"
            color="primary"
            onClick={handleConfirmPostNewJob}
          >
            YES
          </StyledButton>
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={() => setIsModalOpen(false)}
          >
            No
          </StyledButton>
        </div>
      </SimpleModal>
    </>
  );
};

export default BookAnotherTemp;
